/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CognitoBaseService } from '../cognito-base-service';
import { CognitoApiConfiguration } from '../cognito-api-configuration';
import { CognitoStrictHttpResponse } from '../cognito-strict-http-response';

import { cognitoControllerCreateUser } from '../fn/cognito/cognito-controller-create-user';
import { CognitoControllerCreateUser$Params } from '../fn/cognito/cognito-controller-create-user';
import { cognitoControllerDeleteUser } from '../fn/cognito/cognito-controller-delete-user';
import { CognitoControllerDeleteUser$Params } from '../fn/cognito/cognito-controller-delete-user';
import { cognitoControllerDisableUser } from '../fn/cognito/cognito-controller-disable-user';
import { CognitoControllerDisableUser$Params } from '../fn/cognito/cognito-controller-disable-user';
import { cognitoControllerEnableUser } from '../fn/cognito/cognito-controller-enable-user';
import { CognitoControllerEnableUser$Params } from '../fn/cognito/cognito-controller-enable-user';
import { cognitoControllerGetUser } from '../fn/cognito/cognito-controller-get-user';
import { CognitoControllerGetUser$Params } from '../fn/cognito/cognito-controller-get-user';
import { cognitoControllerResendInvite } from '../fn/cognito/cognito-controller-resend-invite';
import { CognitoControllerResendInvite$Params } from '../fn/cognito/cognito-controller-resend-invite';
import { cognitoControllerResetUserPassword } from '../fn/cognito/cognito-controller-reset-user-password';
import { CognitoControllerResetUserPassword$Params } from '../fn/cognito/cognito-controller-reset-user-password';
import { cognitoControllerUpdateUser } from '../fn/cognito/cognito-controller-update-user';
import { CognitoControllerUpdateUser$Params } from '../fn/cognito/cognito-controller-update-user';
import { CognitoCognitoUserResponseDto } from '../models/cognito-cognito-user-response-dto';
import { CognitoMessageResponseDto } from '../models/cognito-message-response-dto';

@Injectable({ providedIn: 'root' })
export class CognitoCognitoService extends CognitoBaseService {
  constructor(config: CognitoApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `cognitoControllerCreateUser()` */
  static readonly CognitoControllerCreateUserPath = '/o2-cognito/cognito/users/{tenant}';

  /**
   * Create a new user in AWS Cognito.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cognitoControllerCreateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cognitoControllerCreateUser$Response(params: CognitoControllerCreateUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>> {
    const obs = cognitoControllerCreateUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new user in AWS Cognito.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cognitoControllerCreateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cognitoControllerCreateUser(params: CognitoControllerCreateUser$Params, context?: HttpContext): Observable<CognitoCognitoUserResponseDto> {
    const resp = this.cognitoControllerCreateUser$Response(params, context);
    return resp.pipe(
      map((r: CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>): CognitoCognitoUserResponseDto => r.body)
    );
  }

  /** Path part for operation `cognitoControllerGetUser()` */
  static readonly CognitoControllerGetUserPath = '/o2-cognito/cognito/users/{id}';

  /**
   * Get a user from AWS Cognito by ID (sub).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cognitoControllerGetUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerGetUser$Response(params: CognitoControllerGetUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>> {
    const obs = cognitoControllerGetUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a user from AWS Cognito by ID (sub).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cognitoControllerGetUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerGetUser(params: CognitoControllerGetUser$Params, context?: HttpContext): Observable<CognitoCognitoUserResponseDto> {
    const resp = this.cognitoControllerGetUser$Response(params, context);
    return resp.pipe(
      map((r: CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>): CognitoCognitoUserResponseDto => r.body)
    );
  }

  /** Path part for operation `cognitoControllerDeleteUser()` */
  static readonly CognitoControllerDeleteUserPath = '/o2-cognito/cognito/users/{tenant}/{id}';

  /**
   * Delete a user from AWS Cognito and MongoDB.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cognitoControllerDeleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerDeleteUser$Response(params: CognitoControllerDeleteUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoMessageResponseDto>> {
    const obs = cognitoControllerDeleteUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a user from AWS Cognito and MongoDB.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cognitoControllerDeleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerDeleteUser(params: CognitoControllerDeleteUser$Params, context?: HttpContext): Observable<CognitoMessageResponseDto> {
    const resp = this.cognitoControllerDeleteUser$Response(params, context);
    return resp.pipe(
      map((r: CognitoStrictHttpResponse<CognitoMessageResponseDto>): CognitoMessageResponseDto => r.body)
    );
  }

  /** Path part for operation `cognitoControllerUpdateUser()` */
  static readonly CognitoControllerUpdateUserPath = '/o2-cognito/cognito/users/{tenant}/{id}';

  /**
   * Complete update of a user in AWS Cognito and MongoDB.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cognitoControllerUpdateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cognitoControllerUpdateUser$Response(params: CognitoControllerUpdateUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoMessageResponseDto>> {
    const obs = cognitoControllerUpdateUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Complete update of a user in AWS Cognito and MongoDB.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cognitoControllerUpdateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cognitoControllerUpdateUser(params: CognitoControllerUpdateUser$Params, context?: HttpContext): Observable<CognitoMessageResponseDto> {
    const resp = this.cognitoControllerUpdateUser$Response(params, context);
    return resp.pipe(
      map((r: CognitoStrictHttpResponse<CognitoMessageResponseDto>): CognitoMessageResponseDto => r.body)
    );
  }

  /** Path part for operation `cognitoControllerEnableUser()` */
  static readonly CognitoControllerEnableUserPath = '/o2-cognito/cognito/users/{tenant}/{id}/enable';

  /**
   * Enable a user in AWS Cognito.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cognitoControllerEnableUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerEnableUser$Response(params: CognitoControllerEnableUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoMessageResponseDto>> {
    const obs = cognitoControllerEnableUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Enable a user in AWS Cognito.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cognitoControllerEnableUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerEnableUser(params: CognitoControllerEnableUser$Params, context?: HttpContext): Observable<CognitoMessageResponseDto> {
    const resp = this.cognitoControllerEnableUser$Response(params, context);
    return resp.pipe(
      map((r: CognitoStrictHttpResponse<CognitoMessageResponseDto>): CognitoMessageResponseDto => r.body)
    );
  }

  /** Path part for operation `cognitoControllerDisableUser()` */
  static readonly CognitoControllerDisableUserPath = '/o2-cognito/cognito/users/{tenant}/{id}/disable';

  /**
   * Disable a user in AWS Cognito.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cognitoControllerDisableUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerDisableUser$Response(params: CognitoControllerDisableUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoMessageResponseDto>> {
    const obs = cognitoControllerDisableUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Disable a user in AWS Cognito.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cognitoControllerDisableUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerDisableUser(params: CognitoControllerDisableUser$Params, context?: HttpContext): Observable<CognitoMessageResponseDto> {
    const resp = this.cognitoControllerDisableUser$Response(params, context);
    return resp.pipe(
      map((r: CognitoStrictHttpResponse<CognitoMessageResponseDto>): CognitoMessageResponseDto => r.body)
    );
  }

  /** Path part for operation `cognitoControllerResetUserPassword()` */
  static readonly CognitoControllerResetUserPasswordPath = '/o2-cognito/cognito/users/{id}/reset-password';

  /**
   * Reset user password in AWS Cognito.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cognitoControllerResetUserPassword()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerResetUserPassword$Response(params: CognitoControllerResetUserPassword$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>> {
    const obs = cognitoControllerResetUserPassword(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Reset user password in AWS Cognito.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cognitoControllerResetUserPassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerResetUserPassword(params: CognitoControllerResetUserPassword$Params, context?: HttpContext): Observable<CognitoCognitoUserResponseDto> {
    const resp = this.cognitoControllerResetUserPassword$Response(params, context);
    return resp.pipe(
      map((r: CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>): CognitoCognitoUserResponseDto => r.body)
    );
  }

  /** Path part for operation `cognitoControllerResendInvite()` */
  static readonly CognitoControllerResendInvitePath = '/o2-cognito/cognito/users/{tenant}/{id}/resend-invite';

  /**
   * Resend invitation email to a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cognitoControllerResendInvite()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerResendInvite$Response(params: CognitoControllerResendInvite$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoMessageResponseDto>> {
    const obs = cognitoControllerResendInvite(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Resend invitation email to a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cognitoControllerResendInvite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cognitoControllerResendInvite(params: CognitoControllerResendInvite$Params, context?: HttpContext): Observable<CognitoMessageResponseDto> {
    const resp = this.cognitoControllerResendInvite$Response(params, context);
    return resp.pipe(
      map((r: CognitoStrictHttpResponse<CognitoMessageResponseDto>): CognitoMessageResponseDto => r.body)
    );
  }

}
